export var ScatterPlotDataType;
(function (ScatterPlotDataType) {
    ScatterPlotDataType["efficientFrontier"] = "efficient_frontier";
    ScatterPlotDataType["scatterPlot"] = "scatter_plot";
})(ScatterPlotDataType || (ScatterPlotDataType = {}));
